export const kPtOverlay4: Record<string, string> = {
  minutes: 'Minutos',
  hour: 'Hora',
  hours: 'Horas',
  day: 'Dia',
  days: 'Dias',
  week: 'Semana',
  weeks: 'Semanas',
  month: 'Mês',
  months: 'Meses',
  quarterOfAYear: 'Trimestre',
  quartersOfAYear: 'Trimestres',
  year: 'Ano',
  years: 'Anos',
  yearOld: 'Ano',
  yearsOld: 'Anos',
  all: 'Todos',
  try: 'Tentativa',
  tries: 'Tentativas',
  attempt: 'Tentativa',
  attempts: 'Tentativas',
  super_administrator: 'Super Administrador',
  rlhsm_admin_: 'Admin. RLHSM',
  super_admin_: 'Super Admin.',
  network_admin_: 'Admin. Rede',
  read_only: 'Só Leitura',
  balance_before: 'Saldo Antes',
  retry: 'Tentar Novamente',
  new_version: 'Nova Versão',
  typeSecret: 'Segredo',
  typeSecrets: 'Segredos',
  firstname: 'Nome',
  first_name: 'Nome',
  lastname: 'Apelido',
  last_name: 'Apelido',
  manual_validation: 'Validação Manual',
  whitelist_reloading: 'Recarregamento da Lista Branca',
  contract_purchase: 'Compra de Contrato',
  card_purchase: 'Compra de Cartão',
  fine: 'Multa',
  fines: 'Multas',
  lost_n_found: 'Perdidos e Achados',
  top_up: 'Carregar',
  amounts: 'Montantes',
  trip_price: 'Preço da Viagem',
  payment_method: 'Método de Pagamento',
  payment_methods: 'Métodos de Pagamento',
  platform: 'Plataforma',
  pax_sales: 'Vendas PAX',
  palmari_sales: 'Vendas Fiscais',
  reseller: 'Revendedor',
  resellers: 'Revendedores',
  reseller_account: 'Conta de Revendedor',
  reseller_accounts: 'Contas de Revendedor',
  register_a_new_reseller_account_: 'Registar uma nova conta de revendedor…',
  session_duration: 'Duração da Sessão',
  session_durations: 'Durações de Sessão',
  ses_duration: 'Duração Ses.',
  session: 'Sessão',
  sessions: 'Sessões',
  amount_max_: 'Montante Máx.',
  amounts_max_: 'Montantes Máx.',
  last_authentication: 'Última Autenticação',
  reseller_card: 'Cartão de Revendedor',
  reseller_cards: 'Cartões de Revendedor',
  serial_number: 'Número de Série',
  no_result_found: 'Nenhum resultado encontrado',
  max_cards: 'Máx. Cartões',
  reseller_sales: 'Vendas de Revendedor',
  cash: 'Numerário',
  credit_card: 'Cartão de Crédito',
  check: 'Cheque',
  bank_transfer: 'Transferência Bancária',
  sales_per_payment_method: 'Vendas por Método de Pagamento',
  manager: 'Gestor',
  managers: 'Gestores',
  register_a_new_manager_: 'Registar um novo gestor…',
  cashier: 'Caixa',
  cashiers: 'Caixas',
  cashier_card: 'Cartão de Caixa',
  cashier_cards: 'Cartões de Caixa',
  no_manager_found: 'Nenhum gestor encontrado',
  no_cashier_found: 'Nenhum caixa encontrado',
  no_card_found: 'Nenhum cartão encontrado',
  no_cashier_card_found: 'Nenhum cartão de caixa encontrado',
  card_registered: 'Cartão registado',
  cards_registered: 'Cartões registados',
  card_serial: 'Número do Cartão',
  card_type: 'Tipo de Cartão',
  customer_card: 'Cartão de Cliente',
  cashier_name: 'Nome do Caixa',
  sales_per_reseller: 'Vendas por Revendedor',
  sales_per_cashier_card: 'Vendas por Cartão de Caixa',
  total_fines_per_line: 'Total de Multas por Linha',
  total_fines_per_hour_of_the_day: 'Total de Multas por Hora do Dia',
  this_action_cannot_be_undone_: 'Esta ação não pode ser anulada.',
  remove_this_cashier_card_question: 'Remover este cartão de caixa?',
  cashier_card_removed: 'Cartão de Caixa removido',
  picture: 'Imagem',
  reseller_account_updated: 'Conta de Revendedor atualizada',
  reseller_account_created: 'Conta de Revendedor criada',
  manager_updated: 'Gestor atualizado',
  manager_created: 'Gestor criado',
  antiPassback: 'Anti-passback',
  availabilityStartDate: 'Início de validade',
  availabilityEndDate: 'Fim de validade',
  controlAlgs: 'Ações de controlo',
  dataModel: 'Modelo de dados',
  durationType: 'Tipo de duração',
  durationValue: 'Duração',
  forbiddenLine: 'Linha proibida',
  forbiddenLines: 'Linhas proibidas',
  forbiddenNetwork: 'Rede proibida',
  forbiddenNetworks: 'Redes proibidas',
  maxPassengers: 'Máx. passageiros',
  nbTripsToLoad: 'Contador',
  validationAlgs: 'Ações de validação',
  validitySections: 'Secções de validade',
  zoneCount: 'Zonas',
  temporalType: 'Tipo',
  spatialEncoding: 'Espacial',
  counterMax: 'Contador máx.',
  support: 'Suporte',
  none: 'Nenhum',
  number_of_zones: 'Número de zonas',
  origin___destination: 'Origem / Destino',
  timeSliding: 'Contínuo',
  timeCalendar: 'Calendário',
  timeFixedDuration: 'Duração fixa',
  timeFixedPeriod: 'Período fixo',
  timeSlidingClendar: 'Calendário contínuo',
  for_sale: 'À venda',
  for_sale_only: 'Apenas à venda',
  parentContracts: 'Contratos pai',
  pointOfSale: 'Ponto de venda',
  pointOfSales: 'Ponto de venda',
  pointsOfSales: 'Pontos de venda',
  point_of_sale: 'Ponto de venda',
  point_of_sales: 'Ponto de venda',
  points_of_sales: 'Pontos de venda',
  account_synchronization_failed: 'Sincronização da conta falhou',
  manager_synchronization_failed: 'Sincronização do gestor falhou',
  email_already_used: 'Email já utilizado',
  phone_number_already_used: 'Número de telefone já utilizado',
  offerProduct_synchronized: 'Produto sincronizado',
  offerProduct_synchronization_failed: 'Sincronização do produto falhou',
  objectRegistered: 'Registado',
  objectArchived: 'Arquivado',
  objectReturned: 'Devolvido',
  objectRegisteredBy: 'Registado por',
  offer_product_updated: 'Produto da oferta atualizado',
  seller_card_removed: 'Cartão do vendedor removido',
  start: 'Início',
  end: 'Fim',
  restart: 'Reinício',
  reboot: 'Reinício',
  reboot_this_equipment_: 'Reiniciar este equipamento?',
  reboot_in_progress: 'Reinício em curso',
  equipment: 'Equipamento',
  from_midnight: 'A partir da meia-noite',
  parameters_saved: 'Parâmetros guardados',
  payment: 'Pagamento',
  payments: 'Pagamentos',
  rejected: 'Rejeitado',
  rejection: 'Rejeição',
  rejections: 'Rejeições',
  failures: 'Falhas',
  payment_status: 'Estado do pagamento',
  refunded: 'Reembolsado',
  paid: 'Pago',
  point_of_sale_reference_already_registered: 'Referência do ponto de venda já registada',
  expand: 'Expandir',
  shrink: 'Reduzir',
  see_all_values: 'Ver todos os valores',
  overall_sales_per_reseller: 'Vendas globais por revendedor',
  overall_sales_per_cashier_card: 'Vendas globais por cartão de caixa',
  overall_sales_per_payment_method: 'Vendas globais por método de pagamento',
  overall_sales_per_cashier_card_for_reseller: 'Vendas globais por cartão de caixa por revendedor',
  overall_sales_per_cashier_card_for_selected_reseller: 'Vendas globais por cartão de caixa por revendedor selecionado',
  overall_sales_per_payment_method_for_reseller: 'Vendas globais por método de pagamento por revendedor',
  reason: 'Motivo',
  reasons: 'Motivos',
  place: 'Local',
  places: 'Locais',
  issued_on: 'Emitido em',
  settled_on: 'Liquidado em',
  barcode: 'Código de barras',
  barcodes: 'Códigos de barras',
  stored_in: 'Armazenado em',
  close_this_session__: 'Fechar esta sessão?',
  you_will_be_redirected_to_the_login_page_: 'Será redirecionado para a página de início de sessão.',
  erased: 'Apagado',
  set_contact: 'Definir contacto',
  contact_saved: 'Contacto guardado',
  configure: 'Configurar',
  unauthorized_date_time: 'Data/hora não autorizada',
  network_section_prohibited: 'Rede / Secção proibida',
  invalid_line: 'Linha inválida',
  tips_sold_out: 'Viagens esgotadas',
  not_yet_valid: 'Ainda não válido',
  unauthorized_date: 'Data não autorizada',
  expired_time: 'Tempo esgotado',
  already_validated_title_apb: 'Título já validado APB',
  expired_title: 'Título expirado',
  prohibited_line: 'Linha proibida',
  prohibited_stop_section: 'Paragem proibida - secção',
  contract_loading_failure: 'Falha no carregamento do contrato',
  contract_loading_in_progress: 'Carregamento do contrato em curso',
  contract_erased: 'Contrato apagado',
  default_reject_code: 'Código de rejeição predefinido',
  card_lost: 'Cartão perdido',
  network_coverage: 'Cobertura de rede',
  moderate: 'Moderado',
  high: 'Alto',
  low: 'Baixo',
  latency: 'Latência',
  network_quality: 'Qualidade da rede',
  control: 'Controlo',
  white_list_reloading: 'Recarregamento da lista branca',
  payed: 'Pago',
  validity_start: 'Início de validade',
  validity_stop: 'Fim de validade',
  last_validation_date: 'Data da última validação',
  report_lifetime__d_: 'Duração do relatório (d)',
  validation_time: 'Tempo de validação',
  validation_time__s_: 'Tempo de validação (s)',
  almaviva_process_time: 'Tempo de processamento Almaviva',
  almaviva_process_time__s_: 'Tempo de processamento Almaviva (s)',
  abt_status: 'Estado ABT',
  valid_ticket: 'Bilhete válido',
  blacklisted_ticket: 'Bilhete em lista negra',
  expired_ticket: 'Bilhete expirado',
  ticket_not_yet_valid: 'Bilhete ainda não válido',
  antipassback: 'Antipassback',
  used_ticket: 'Bilhete utilizado',
  ticket_out_of_geographical_validity: 'Bilhete fora da validade geográfica',
  ticketless_support: 'Suporte sem bilhete',
  no_valid_ticket: 'Nenhum bilhete válido',
  daterange_cannot_exceed_24_hours: 'O intervalo de datas não pode exceder 24 horas',
}
